/**
 * Safely redirect the browser to an OAuth authorize URL, dealing with the
 * "app is iframed inside Emergent preview" edge-case.
 *
 * Why this exists (Wave 1u3 fix) :
 *   Microsoft (`login.microsoftonline.com`) and Google (`accounts.google.com`)
 *   send `X-Frame-Options: DENY`. When OFManager runs inside the Emergent
 *   preview iframe, redirecting the current window keeps us inside the
 *   iframe → providers refuse and show "n'autorise pas la connexion".
 *
 * Strategy :
 *   1. If we're at the top window already → plain `window.location.href`.
 *   2. If we're iframed → try `window.top.location.href` (works for same-origin
 *      embeds).
 *   3. Cross-origin iframe → `window.open` in a new tab as a last resort, so
 *      the provider gets a real top-level browsing context.
 */
export function oauthRedirect(authUrl, { onAfterPopup } = {}) {
  if (!authUrl) return;
  const isFramed = typeof window !== 'undefined' && window.top && window.top !== window.self;
  if (isFramed) {
    try {
      window.top.location.href = authUrl;
      return;
    } catch (e) {
      // Cross-origin: top.location.href throws.
      window.open(authUrl, '_blank', 'noopener,noreferrer');
      if (typeof onAfterPopup === 'function') onAfterPopup();
      return;
    }
  }
  window.location.href = authUrl;
}
